const store = "userStore";
const contentType1 = "application/json";

export { store, contentType1 };
